import React, { useContext, useEffect, useState } from "react";
import "./Redeem.css";
import { axiosInstance } from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


export function Redeem() {
  const [bank, setBank] = useState();
  const [accountNumber, setAccountNumber] = useState();
  const [ifsc, setIfsc] = useState();
  const [agentname, setAgentName] = useState();
  const [earnedPoints, setEarnedPoints] = useState();
  const [totalEarnedPoints, setTotalEarnedPoints] = useState();
  const [amount, setAmount] = useState();
  //   console.log("amount",amount);
  const [minWithDrawal, setMinWidthDrawal] = useState(null);
  const [loading, setLoading] = useState(false);

  // fetch agent request withdrawal
  async function fetchAgentRequestWithDrawal() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/admin/internal-settings/1/`);

      if (response.data?.status === "success" || response.data?.id) {
        const settingsData = response.data.data || response.data;

        // Store the agent withdrawal limit value
        if (settingsData?.agent_withdraw_limit) {
          setMinWidthDrawal(settingsData.agent_withdraw_limit);
        } else {
          console.warn("agent_withdraw_limit not found in response data");
        }
      } else {
        console.warn("Unexpected response:", response.data);
      }
    } catch (error) {
      console.error("Error fetching agent settings data:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAgentRequestWithDrawal();
  }, []);

  console.log("min value:", minWithDrawal);

  const loadData = async () => {
    try {
      const response = await axiosInstance.get("/agent/registration");
      if (response.data.status === "success") {
        const details = response.data.data;

        // Set agent details
        setBank(details.bank_name || "");
        setIfsc(details.ifsc_code || "");
        setAccountNumber(details.bank_account_number || "");
        setAgentName(`${details.first_name || ""} ${details.last_name || ""}`);

        // Set points
        setEarnedPoints(details.user_referal_code?.points ?? 0);
        setTotalEarnedPoints(details.user_referal_code?.points ?? 0); // if total points are different, adjust accordingly
      } else {
        toast.error(response.data.message || "Unable to fetch agent data");
      }
    } catch (error) {
      console.error("Error fetching agent data:", error);
      toast.error("Unable to fetch agent data");
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  async function handleWithdraw() {
    try {
      const numericAmount = Number(amount);
      if (!numericAmount || numericAmount <= 0) {
        toast.error("Please enter a valid amount");
      } else if (earnedPoints < minWithDrawal) {
        toast.error(
          `Insufficient balance. Minimum balance required is ${minWithDrawal} points.`
        );
      } else if (numericAmount < minWithDrawal) {
        toast.error(`Minimum withdrawal amount is ${minWithDrawal}`);
      } else {
        const numericAmount = Number(amount);
        const response = await axiosInstance.post(
          "/agent/create-withdraw-request/",
          {
            points_to_withdraw: numericAmount,
          }
        );
        if (
          response.data.status === "success" ||
          response.data.status === true
        ) {
          toast.success(response.data.message || "Withdraw request sent");
          loadData();
          setAmount("");
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      console.error("Withdraw error:", error);

      toast.error("Enter Amount", error);
    }
  }

  return (
    <>
      <ToastContainer />
      <div className="redeemBg">
        <div className="container redeemContainer">
          <div>
            <div className="account-title">
             Account Details
            </div>
            <div className="account-content">
              <div className="accountDetails">
                <span> Name :</span>
                <span>{agentname}</span>
              </div>
              <div className="accountDetails">
                <span> Account Number :</span>
                <span>{accountNumber}</span>
              </div>
              <div className="accountDetails">
                <span> Bank Name :</span>
                <span>{bank}</span>
              </div>
              <div className="accountDetails">
                <span> IFSC Code :</span>
                <span>{ifsc}</span>
              </div>
              <div className="accountDetails">
                <span>Available Amount :</span>
                <span>{earnedPoints}/-</span>
              </div>
              <div className="accountDetails">
                <span>Minimum Withdraw Amount :</span>
                <span>{minWithDrawal || 0}/-</span>
              </div>
            </div>
            <div className="amountContainer">
              <label>Enter amount to withdraw :</label>
              <input
                type="text"
                onChange={(e) => setAmount(e.target.value)}
                value={amount}
              />
            </div>
            <div className="btnAmountSubmit">
              <button onClick={handleWithdraw}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
